import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Language, LanguageList } from '../../model/language.model';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { LanguageService } from '../../service/language.service';
import { LanguagesTranslateComponent } from '../../feature/languages-translate/languages-translate.component';
import { DictionnaryService } from '../../service/dictionnary.service';
import { SharedAppState } from '../../store/app.states';
import { Store } from '@ngrx/store';
import { FuseSplashScreenService } from '../../@fuse/services/splash-screen';
import * as authActions from '../../../../../shared/src/lib/store/actions/auth.actions';
@Component({
    selector: 'languages-translate-fuse',
    templateUrl: './languages-translate-fuse.component.html',
    styleUrls: ['./languages-translate-fuse.component.scss']
})
export class LanguagesTranslateFuseComponent extends LanguagesTranslateComponent {
    bundle: any;

    @Input() updateBundle: boolean = true;

    private fuseSplashScreenService = inject(FuseSplashScreenService);

    /**
     * Constructor
     */
    constructor(
        dictionnaryService: DictionnaryService,
        translateService: TranslateService,
        languageService: LanguageService,
        private store: Store<SharedAppState>
    ) {
        super(dictionnaryService, translateService, languageService);
        this.store.select("auth")
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(state => {
                this.bundle = JSON.parse(state.xBundleRecurring)
            });
    }

    /**
     * Set the active lang
     *
     * @param language: Language
     */
    setActiveLang(language: { code: any, label: any }): void {
        // ✅ Afficher le splash screen pendant le chargement
        this.fuseSplashScreenService.show();
        setTimeout(() => {

            this.activeLang = language;
            const _lang = language.code;
            localStorage.setItem('language', _lang);
            if (this.updateBundle) {
                this.updateLanguageInBundle(_lang);
            }
            this.translateService.setDefaultLang(_lang);
            this.translateService.use(_lang);
            this.dictionnaryService.getDictionnary2(_lang)
                .subscribe(res => {
                    if (res) {
                        this.translateService.setTranslation(_lang, res);
                    }

                    // ✅ Cacher le splash screen une fois les traductions chargées
                    setTimeout(() => {
                        this.fuseSplashScreenService.hide();
                    }, 300); // Petit délai pour s'assurer que le DOM est mis à jour
                });
        }, 300); // Petit délai pour s'assurer que le DOM est mis à jour
    }

    updateLanguageInBundle(code): void {
        this.bundle.language = code;
        this.store.dispatch(authActions.updateBundleRecurring({ xBundleRecurring: JSON.stringify(this.bundle) }));
    }
}
